document.querySelectorAll('.bw-video[data-video]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var w = document.createElement('div');
    w.style.cssText = 'aspect-ratio:16/9;border-radius:10px;overflow:hidden;max-width:1000px;margin-inline:auto';
    w.innerHTML = '<iframe width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(btn.dataset.video) + '?autoplay=1" title="' +
      (btn.getAttribute('aria-label') || 'Video') +
      '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    btn.replaceWith(w);
  }, { once: true });
});
